import React from 'react';
import Page from './Page';

const MissionPage = () => (
  <Page eyebrow="WHY WE BUILD" title="Our Mission">
    <p>
      To democratise self-improvement for every Indian — making the world's
      best non-fiction wisdom accessible, actionable and personal in their
      own language.
    </p>
    <p className="legal-pull">Less Noise. More Thought.</p>
    <p>
      We measure success not in pageviews or downloads, but in the number of
      readers who finish an iCraftz card and actually try the idea — that
      week, in their life, in their language.
    </p>
  </Page>
);

export default MissionPage;
